import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthService, GenesisUnitOfWork, ReportService } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-weld-shop-overview',
    templateUrl: './weld-shop-overview.component.html',
    styleUrls: ['./weld-shop-overview.component.scss'],
    standalone: false
})
export class WeldShopOverviewComponent implements OnInit {
    weldShopParts: any[];
    categories: string[] = ['20','30','35'];
    selectedCategories: string[] = ['35'];
    processing = false;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(
        private uow: GenesisUnitOfWork,
        private router: Router,
        public auth: AuthService,
        private modalService: BsModalService,
        private appInfo: AppInformationService,
        private reportService: ReportService
    ) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.weldShopParts = await this.uow.getWeldShopParts(this.selectedCategories);
        this.weldShopParts.forEach((weldShopPart) => {
            const negativeQty = _(this.weldShopParts.filter((part) => part.subPartNumber === weldShopPart.subPartNumber && part.partsNeeded < 0)).sumBy((part) => part.partsNeeded);
            const remainingQty = weldShopPart.subInStock + negativeQty;
            weldShopPart.negativeQty = negativeQty;
            weldShopPart.remainingQty = remainingQty;
        });
    }

    async search() {
        if (this.selectedCategories.length === 0) this.weldShopParts = [];
        else await this.getData();
    }

    hasChanges() {
        return this.uow.hasChanges();
    }

    rowPrepare(e) {
        if (e.rowType === 'data') {
            // console.log(e);
            if (!!e.data && e.data.partsNeeded < 0) {
                e.cells.forEach((cell) => {
                    if (cell.column.dataField === 'partsNeeded') {
                        cell.cellElement.className = cell.cellElement.className + ' negative-projected-inventory';
                    }
                });
            }
        } else if (e.rowType === 'groupFooter') {
            // console.log('e', e);
            if (!!e.data && e.data.items[0].remainingQty < e.data.items[0].subpartReOrderMin) {
                // e.element.className = e.element.className + ' low-inventory';
                e.rowElement.className = e.rowElement.className + ' weld-low-inventory';
                // e.cells.forEach((cell) => {
                //     if (cell.column.dataField = 'partLinkQty')
                //     {
                //         console.log('cell',cell);
                //         cell.cellElement = 'low-inventory';
                //         // console.log(cell.cellElement);
                //     }
                //     // cell.columns.forEach(column => {

                //     // });

                //     // if (column.dataField === 'partLinkQty') {
                //     //     // db: groupFooter cells don't have the cellElement property
                //     //     // cell.cellElement.className = cell.cellElement.className + ' feed-batch-review-required';
                //     // }
                // });
            }
        }
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async open(id: number) {
        // this.router.navigate(['/parts/' + (partId ? partId : 'new')]);
    }
    async rowDoubleClick(e) {
        // await this.open(e.data.id);
    }

    // this method is used to clear the selection when the user searches for something
    onOptionChanged(e) {
        if (e.fullName === 'searchPanel.text') {
            e.component.__searchChanged = true;
        }
        const filterCheck = _.includes(e.fullName, 'filterValue');
        if (filterCheck) {
            this.dataGrid.instance.clearSelection();
        }
    }

    // this method is used to clear the selection when the user searches for something
    onContentReady(e) {
        if (e.component.__searchChanged) {
            //__searchChanged is for the search box
            e.component.__searchChanged = false;
            this.dataGrid.instance.clearSelection();
        }
    }
}
